import { FormikProps } from 'formik';
import { ISettingsValues } from '../../Settings';
import { Input } from '../../../components/Common';
import { CustomField } from '../../../commonTypes/organization.types';
import { useState } from 'react';
import { Modal } from '../../../components/Common';
import EditOrganizationCustomFields from '../../../components/modalContent/EditOrganizationCustomFields';
import { useTranslation } from '../../../hooks/useTranslation';

interface ICustomComponentProps<ISettingsValues> {
    context: FormikProps<ISettingsValues>;
    openEditCustomFiledsModal: boolean;
    setIsEditCustomComponentModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const CustomComponent = ({ context, openEditCustomFiledsModal, setIsEditCustomComponentModalOpen }: ICustomComponentProps<ISettingsValues>) => {
    const { t } = useTranslation('settings');
    const [newCustomField, setNewCustomField] = useState('');
    const [customFields, setCustomFields] = useState<CustomField[]>(context.initialValues.customFields ?? []);

    const { setFieldValue } = context;

    const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = event => {
        if (event.key === 'Enter' && event.target instanceof HTMLInputElement) {
            event.preventDefault();
            const updatedCustomFields = [
                ...customFields,
                {
                    name: newCustomField,
                    label: newCustomField,
                    value: '',
                },
            ];
            setCustomFields(updatedCustomFields);
            setFieldValue('customFields', updatedCustomFields);
            setNewCustomField('');
        }
    };

    const handleChange = (fieldName: string, value: string) => {
        const updatedCustomFields = customFields.map(field => {
            if (field.name === fieldName) {
                return { ...field, value };
            }
            return field;
        });
        setCustomFields(updatedCustomFields);
        setFieldValue('customFields', updatedCustomFields);
    };

    return (
        <div className="custom-fields">
            <div className="custom-fields__content">
                {!!customFields?.length &&
                    customFields.map((field: CustomField) => {
                        return (
                            <Input
                                key={field.name}
                                id={field.name}
                                value={field.value}
                                label={field.label}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange(field.name, e.target.value)}
                            />
                        );
                    })}
                <div className="custom-fields__content--new">
                    <label className="paragraph-4 custom-fields__content--new--label">{t('insertLabelName')}</label>
                    <Input
                        borderType="dashed"
                        value={newCustomField}
                        placeholder={t('insertText')}
                        id="new-custom-field"
                        onChange={e => setNewCustomField(e.target.value)}
                        onKeyDown={handleKeyDown}
                    />
                </div>
            </div>

            <Modal isVisible={openEditCustomFiledsModal && !!customFields.length} closeModal={() => setIsEditCustomComponentModalOpen(false)}>
                <EditOrganizationCustomFields
                    customFields={customFields}
                    context={context}
                    close={() => setIsEditCustomComponentModalOpen(false)}
                    setCustomFields={setCustomFields}
                />
            </Modal>
        </div>
    );
};

export default CustomComponent;
